import React, { FC } from 'react';

import { Box } from '@rover/kibble/core';
import Section from '@rover/kibble/patterns/Section';

import MarketingEmailCapture from '../Marketing/MarketingEmailCapture';

import AboutRoverLinks from './AboutRoverLinks';
import CookieConsentLink from './CookieConsentLink';
import LearnMoreLinks from './LearnMoreLinks';
import NeedHelpLinks from './NeedHelpLinks';

const FooterLinks: FC = () => {
  return (
    <Section px="0x" py="3x" width="100%">
      <Box display={['block', 'block', 'flex']}>
        <Box
          flexWrap="wrap"
          display={['block', 'flex']}
          alignContent="flex-start"
          justifyContent="space-between"
          width="100%"
          pr={['0x', '0x', '10x']}
        >
          <LearnMoreLinks />

          <AboutRoverLinks />

          <NeedHelpLinks />

          <CookieConsentLink />
        </Box>

        <MarketingEmailCapture />
      </Box>
    </Section>
  );
};

export default FooterLinks;
